/** Rich setup narrative (display / price story — not a separate score path). */

export function buildTradeSetupWinnerStory(symbol, t, type, o) {
  if (!type || type === "MOMENTUM") return "";
  const sym = (symbol || "").toUpperCase();
  const g = t.gap || {};
  const ed = t.earningsDrift || {};
  const bf = t.bullFlag || {};
  const rb = t.rangeBreakout || {};
  const sb = t.supportBounce || {};
  const vcp = t.vcp || {};
  if (type === "VCP") {
    const tag = vcp.breakout_confirmed
      ? "Volatility contraction resolved to the upside with volume."
      : "Volatility is contracting and volume is drying up — classic VCP coiling.";
    const pivot = vcp.pivotR1 != null ? `$${vcp.pivotR1}` : "the pivot band";
    return `${sym} — ${tag} Coil high/low (20D) near $${vcp.coilHigh20 ?? "—"} / $${vcp.coilLow20 ?? "—"}. Pivot area ${pivot}. ${vcp.breakout_confirmed ? `Measured targets near $${vcp.vcpT1 ?? "—"} / $${vcp.vcpT2 ?? "—"}` : `Watch for a high-volume close through the coil top; targets on confirmation near $${vcp.vcpT1 ?? "—"} / $${vcp.vcpT2 ?? "—"}`}, stop idea near $${vcp.vcpStop ?? "—"}.`;
  }
  if (type === "GAP_AND_GO") {
    return `${sym} gapped up about ${g.gap_pct != null ? Math.abs(g.gap_pct).toFixed(1) : "—"}% at the open on elevated volume. The gap lines up with the trend and money flow is supportive. Targets near $${g.gapT1 ?? "—"} and $${g.gapT2 ?? "—"} with a stop idea near $${g.gapStop ?? "—"} below the gap area.`;
  }
  if (type === "GAP_FILL") {
    return `${sym} gapped up but the move looks weak (light volume, against the larger trend). Traders often watch for a move back toward the prior close near $${g.yesterdayClose ?? "—"}.`;
  }
  if (type === "EARNINGS_DRIFT") {
    return `${sym} recently reported earnings; estimates were beaten and price has held above the report-day area. Flow remains positive (CMF ${o.cmf != null ? o.cmf.toFixed(2) : "—"}). Drift targets near $${ed.driftT1 ?? "—"} / $${ed.driftT2 ?? "—"}, stop near $${ed.driftStop ?? "—"}.`;
  }
  if (type === "BULL_FLAG") {
    return `${sym} showed a sharp rally (the pole) then a tight pullback. ${bf.breakout_confirmed ? "Price broke the flag with volume — follow-through levels near $" + (bf.flagT1 ?? "—") + " and $" + (bf.flagT2 ?? "—") + "." : "The flag is still forming — watch for a breakout with volume."} Stop idea near $${bf.flagStop ?? "—"}.`;
  }
  if (type === "RANGE_BREAKOUT") {
    return `${sym} compressed in a tight range (${rb.narrowDays ?? "—"} narrow sessions) then ${rb.range_breakout_confirmed ? "broke out on strong volume" : "is still coiling"}. Range targets near $${rb.rangeT1 ?? "—"} / $${rb.rangeT2 ?? "—"}, stop near $${rb.rangeStop ?? "—"}.`;
  }
  if (type === "SUPPORT_BOUNCE") {
    return `${sym} pulled back about ${sb.pullback_pct ?? "—"}% in an uptrend and is testing support (${sb.support_count ?? 0} nearby levels). ${sb.bounce_trigger ? "A reclaim with volume fired." : "Watch for a clean reclaim."} Targets $${sb.sbT1 ?? "—"} / $${sb.sbT2 ?? "—"}, stop $${sb.sbStop ?? "—"}.`;
  }
  return "";
}
